import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableDspRetrieval = loadable(() => import('./DspRetrieval'), {
  fallback: <LoadingScreen />,
});

export default LoadableDspRetrieval;
